import React, { Component } from "react";
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import NovedadesHelper from '../../../../../Common/Helpers/NovedadesHelper';

class DenominacionTarjeta extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(2, this.props.codigoNovedad, event.target.value, event.target.id);
    }
    /**
     * 
     */
    render() {
        const { props } = this;
        const { tarjeta, data } = props;

        let denominacionTarjetaNovedad = NovedadesHelper.InputConNovedadPorCampos(this.props.codigoNovedad,
            tarjeta.Denominacion,
            data.novedadesTarjetaDatos,
            data.esNovedadEditada,
            [{ Clave: "TarjetaCreditoId", Valor: tarjeta.TarjetaCreditoId }]);

        const componenteInput = <input className="form-control" id={tarjeta.TarjetaCreditoId}
            value={denominacionTarjetaNovedad.descripcion} onChange={this.changeInput} />;

        return (
            <div className="col-xs-12">
                <GenericEditPanel
                    componente={componenteInput}
                    novedad={denominacionTarjetaNovedad.novedadInput}
                    permisoUsuario={data.funcionesDelUsuario}
                    seEstaEditando={data.seEstaEditando}
                    textPanel={denominacionTarjetaNovedad.descripcion || "Sin especificar"}
                    title="Denominación de la tarjeta"
                    value={denominacionTarjetaNovedad.descripcion}

                    aceptChanges={(value) => this.props.guardarNovedad(value, null, tarjeta.TarjetaCreditoId)}
                    confirmarNovedad={() => this.actualizarNovedadEstado(denominacionTarjetaNovedad.novedadInput, 2, tarjeta.CuentaTarjetaId)}
                    changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                    denegarNovedad={() => this.actualizarNovedadEstado(denominacionTarjetaNovedad.novedadInput, 3, tarjeta.CuentaTarjetaId)}
                    mostrarModificaciones={this.props.mostrarModal}
                    revert={this.props.cancelar}
                />
            </div>
        )
    }
}

export default DenominacionTarjeta;